export const showTimeButton = () => {

  const showTimeBtns = document.querySelectorAll(".js-show-time");
  const hideTime = document.querySelectorAll(".js-hide-time");

  if ( showTimeBtns ) {
    for( let btn of showTimeBtns ) {
    
      let timeBtns = btn.parentElement.querySelectorAll(".button_time");
  
      btn.addEventListener("click",function(){
        btn.classList.toggle("button_hidden");
        for ( let time of timeBtns ){
          time.classList.toggle("button_hidden");
        }
      });
  
    }

    if ( hideTime ){
      for ( let elem of hideTime ) {
        elem.addEventListener("click",function(event){
          if (this == event.target){

            let showTimeBtn = elem.parentElement.querySelector(".js-show-time");

            if ( showTimeBtn.classList.contains("button_hidden") ) {
              showTimeBtn.classList.remove("button_hidden");

              let timeBtns = elem.parentElement.querySelectorAll(".button_time"); 
  
              for ( let time of timeBtns ){
                time.classList.add("button_hidden");
              }
            }
  
          }
        });
      }
    }




  }
  
  
  
  

  
  

  /* const eventsMore = document.querySelector(".js-events-slide-open");
  const eventsSlide = document.querySelector(".events__slide");
  const eventsHidden = document.querySelector(".events__hidden");

  eventsMore?.addEventListener("click", function(e){

    e.preventDefault();

    

    if ( eventsMore.classList.contains("events__more_open") ){
      eventsSlide.style.height = 0 + "px";
    } else {
      eventsSlide.style.height = eventsHidden.offsetHeight + "px";
    }

    eventsMore.classList.toggle("events__more_open");
    

  }); */

}